import { useEffect, useMemo, useState } from "react";
import AppsRevenue from "./AppsRevenue";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router";
import { SiteActionCreators } from "../../store/actions/site";

const Apps = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserApps, setSelectedUserApps] = useState([]);

  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useMemo(() => params.user, [params.user]);

  const apps = useSelector((state) => state?.site?.info?.user?.apps);
  const appUsers = useSelector(
    (state) => state?.site?.info?.user?.appUsers ?? []
  );

  const allUsersObj = useMemo(
    () => ({
      id: "all-users",
      name: "All Users",
      app: apps,
      email: "",
    }),
    [apps]
  );

  useEffect(() => {
    const _appUsers = Array.isArray(appUsers) ? appUsers : [appUsers];
    const userListArr = [allUsersObj, ..._appUsers];
    const searchedId = params.user;
    if (!searchedId) {
      const selected = userListArr.length > 1 ? userListArr[1] : userListArr[0];
      navigate(`/apps/${selected?.id}`);
    } else {
      const filteredUser = userListArr.filter((user) => user.id === searchedId);
      if (filteredUser.length) {
        dispatch(SiteActionCreators.selectUser(searchedId));
        setSelectedUserApps(filteredUser[0].app);
      } else {
        navigate("/apps/all-users");
      }
    }
    setUsers([...userListArr]);
  }, [allUsersObj, appUsers, navigate, user, dispatch]);

  return <AppsRevenue users={users} selectedUserApps={selectedUserApps} />;
};

export default Apps;
